/* src/app/pages/user/totp-setup/totp-setup.component.scss */
/*# sourceMappingURL=totp-setup.component.css.map */
